export const LESSONS_PATH = '/explore/lessons';

export const lessonPlayerPath = (courseId: string): string => `${LESSONS_PATH}/${courseId}`;
